export default "__VITE_ASSET__CUor6hQw__"